import styles from "../Style.module.css";
import profile from "../images/profile.png";
import { IoDocumentText } from "react-icons/io5";
import styled, { keyframes } from "styled-components";
import { zoomInRight } from "react-animations";
import { zoomInLeft } from "react-animations";

const zoomAnimation = keyframes`${zoomInRight}`;
const zoomAnimationLeft = keyframes`${zoomInLeft}`;

const ZoomLeftDiv = styled.div`
  animation: 2s ${zoomAnimationLeft};
`;

const ZoomDiv = styled.div`
  animation: 2s ${zoomAnimation};
  & > div:nth-child(1) {
    margin-top: 5%;
  }
  & > div:nth-child(1) > h1 {
    font-family: "Comic Neue", cursive;
    color: white;
  }
  & > div:nth-child(2) {
    margin-top: 1%;
  }
  & > div:nth-child(2) > h1 {
    width: 65%;
    padding: 10px 20px;
    font-family: "Comic Neue", cursive;
    color: #b026ff;
    font-size: 100px;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 30px;
  }
  & > div:nth-child(3) {
    margin-top: 1%;
  }
  & > div:nth-child(3) > h1 {
    font-family: "Comic Neue", cursive;
    color: white;
  }
  & > div:nth-child(4) {
    margin-top: 5%;
    display: flex;
  }
  & > div:nth-child(4) > a > button {
    width: 120%;
    padding: 10px 20px;
    background-color: #b026ff;
    color: black;
    font-family: "Comic Neue", cursive;
    font-size: 30px;
    font-weight: bold;
    border: none;
    border-radius: 20px;
    box-shadow: 0 0 5px 5px black;
  }
  & > div:nth-child(4) > a > button:hover {
    background-color: black;
    color: #b026ff;
    border-radius: 20px;
    box-shadow: 0 0 2.5px 2.5px white;
    cursor: pointer;
  }
  & > div:nth-child(4) > div {
    color: white;
    font-size: 40px;
    margin-top: 1%;
    margin-left: 5%;
  }
  @media screen and (max-width: 1310px) {
    & > div:nth-child(2) > h1 {
      width: 65%;
      padding: 10px 20px;
      font-family: "Comic Neue", cursive;
      color: #b026ff;
      font-size: 80px;
      background-color: rgba(0, 0, 0, 0.8);
      border-radius: 30px;
      text-align: center;
    }
  }
  @media screen and (max-width: 1047px) {
    & > div:nth-child(2) > h1 {
      width: 65%;
      padding: 10px 20px;
      font-family: "Comic Neue", cursive;
      color: #b026ff;
      font-size: 60px;
      background-color: rgba(0, 0, 0, 0.8);
      border-radius: 30px;
      text-align: center;
    }
  }
  @media screen and (max-width: 768px) {
    & > div:nth-child(1) {
      margin-top: 10%;
      text-align: center;
    }
    & > div:nth-child(2) {
      margin: 5% auto;
      width: 90%;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    & > div:nth-child(2) > h1 {
      font-size: 40px;
      font-family: "Comic Neue", cursive;
      color: #b026ff;
      background-color: rgba(0, 0, 0, 0.8);
      padding: 10px 15px;
      border-radius: 15px;
      text-align: center;
    }
    & > div:nth-child(3) {
      margin-top: 2%;
      text-align: center;
    }
    & > div:nth-child(3) > h1 {
      font-family: "Comic Neue", cursive;
      color: white;
    }
    & > div:nth-child(4) {
      margin-top: 5%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    & > div:nth-child(4) > a > button {
      width: 120%;
      padding: 10px 20px;
      background-color: #b026ff;
      color: black;
      font-family: "Comic Neue", cursive;
      font-size: 25px;
      font-weight: bold;
      border: none;
      border-radius: 20px;
    }
    & > div:nth-child(4) > div {
      color: white;
      font-size: 40px;
      margin-top: 2%;
      margin-left: 10%;
    }
  }
`;

export const Home = () => {
  return (
    <>
      <div className={styles.home}>
        <div className={styles.profile_div}>
          <ZoomLeftDiv>
            <img src={profile} alt="profile" />
          </ZoomLeftDiv>
        </div>
        <div className={styles.des_div}>
          <ZoomDiv>
            <div>
              <h1>Hi, My Name is</h1>
            </div>
            <div>
              <h1>Pulkit Tyagi</h1>
            </div>
            <div>
              <h1>I am a Full-Stack Web Developer</h1>
            </div>
            <div>
              <a
                href="https://drive.google.com/file/d/1sJ_E922BoWjpu366OZrVGL3UVl4_l4Jn/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button>Resume</button>
              </a>
              <div>
                <IoDocumentText />
              </div>
            </div>
          </ZoomDiv>
        </div>
      </div>
    </>
  );
};
